
import type { PropOptions } from 'vue';
import Vue from 'vue';
import { variants } from './types';

export default Vue.extend({
  name: 'BravadoPillV2',
  props: {
    active: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    variant: {
      type: String,
      default: variants.Border,
      validator: value => Object.values(variants).includes(value as unknown as variants),
    } as PropOptions<variants>,
    size: {
      type: String,
      default: 'md',
      validator: (value: string) => ['md', 'lg'].includes(value),
    },
    customStyles: {
      type: Object,
      default: () => ({}),
    } as PropOptions<Record<string, string>>,
  },
  computed: {
    rootStyles(): Record<string, boolean> {
      return {
        'bravado-pill': true,
        [`bravado-pill--${this.variant}`]: true,
        [`bravado-pill--${this.size}`]: true,
        'bravado-pill--active': this.active,
        'bravado-pill--with-image': Boolean(this.$slots['prepend-icon']),
      };
    },
  },
});
